import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1wdyenfg: FaireBrandEntity = {
  token: "b_1wdyenfg",
  type: "brand",
  name: "Klee Naturals",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1d38be93c1d5de04373a58dc56611f580419c3d6829c4c8385020618d9c138de/1550079580.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ea5e96795c517644470124ed188bed16fb20801a86161f32454503d430cd9954.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1d38be93c1d5de04373a58dc56611f580419c3d6829c4c8385020618d9c138de/1550079580.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ea5e96795c517644470124ed188bed16fb20801a86161f32454503d430cd9954.jpeg",
  location: "Denton, TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 70,
  isTopShop: true,
  isInsider: true,
  description:
    "Unable to find safe play makeup for her daughters, a mom set out to formulate her own. Today, Klee Naturals continues to offer parents the peace of mind by making natural mineral play makeup, mineral makeup, water-based nail polish and bath products for our little ones. All products are made in USA. A gift is donated to a children's hospital with each product sold.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:59.828Z",
    importedBy: "entity-db-cli",
  },
};
